import { loadStripe } from "@stripe/stripe-js"
import { httpsCallable } from 'firebase/functions';
import { getConfigValues } from '../lib/remote-config';
import { functions } from '../lib/firebase';
import { trackSubscriptionStart, trackSubscriptionCancel, trackError } from '../lib/analytics';

const getStripePromise = async () => {
  const { stripePublicKey } = getConfigValues();
  return loadStripe(stripePublicKey);
};

export class SubscriptionService {
  static async createSubscription(planName, price) {
    try {
      const createStripeCheckout = httpsCallable(functions, 'createCheckoutSession')
      const { data } = await createStripeCheckout()
      
      if (data?.sessionId) {
        trackSubscriptionStart(planName, price)
        const stripe = await getStripePromise()
        await stripe?.redirectToCheckout({
          sessionId: data.sessionId,
        })
      }
    } catch (error) {
      trackError('subscription_creation', error.message)
      console.error("Error creating subscription:", error)
      throw error
    }
  }

  static async checkAndResetMonthlyDebates() {
    try {
      const checkReset = httpsCallable(functions, 'checkMonthlyReset');
      const { data } = await checkReset();
      return data;
    } catch (error) {
      console.error("Error checking monthly reset:", error);
      throw error;
    }
  }

  static async getRemainingChats() {
    try {
      const response = await fetch("/api/remaining-chats")
      const data = await response.json()
      return data.remaining
    } catch (error) {
      console.error("Error fetching remaining chats:", error)
      return 0
    }
  }

  static async getCurrentPlan() {
    try {
      const response = await fetch("/api/current-plan")
      const data = await response.json()
      return data.plan
    } catch (error) {
      console.error("Error fetching current plan:", error)
      return "free"
    }
  }

  static async manageSubscription() {
    try {
      const createPortalSession = httpsCallable(functions, 'createCustomerPortalSession');
      const { data } = await createPortalSession();
      
      if (data?.url) {
        // We'll track subscription cancellation in the webhook handler on the backend
        // since that's when we know for sure it was cancelled
        window.location.href = data.url;
      } else {
        throw new Error('No portal URL received');
      }
    } catch (error) {
      trackError('subscription_portal', error.message)
      console.error("Error accessing subscription portal:", error);
      throw error;
    }
  }
}

